<ng-container *ngFor="let relation of relations; let index = index">
  <div
    preventDefault
    *ngIf="!(productTitle.includes('Piccolo') && index == 1)"
    class="relation-entry action me-2 position-relative"
    (click)="openRelation(relation)"
  >
    {{ relation.value }}
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M2.3125 4.25L5.8125 7.75L9.3125 4.25" stroke="#1D1D1D" />
    </svg>
    <div class="select" [ngClass]="{ active: relation._active }">
      <ng-container *ngFor="let option of relation.entries">
        <div
          class="options action"
          [ngClass]="{ disabled: option?.options?.length == 0 }"
          (click)="selectOption(relation, option)"
          *ngIf="!option.hidden"
        >
          {{ option.label }}
        </div>
      </ng-container>
    </div>
  </div>
</ng-container>
